import React from "react";
import PropTypes from "prop-types";
import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";
import MUIEditIcon from "@mui/icons-material/Edit";
import MUIAutoComplete from "@mui/material/Autocomplete";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUIAlert from "@mui/material/Alert";
import MUICheckbox from "@mui/material/Checkbox";
import MUIIconButton from "@mui/material/IconButton";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import TileRegion from "../../../Tile/TileRegion";
import MainContext from "../../../../Context/MainContext/MainContext";
import DialogSearchLocation from "../../../Dialog/Search/DialogSearchLocation";
import User from "../../../../Utility/Crud/User";

export default class CardAccountGeneral extends CardClass {
  constructor(props) {
    super(props);

    this.state.locationDialogOpen = false;
  }

  static contextType = MainContext; // For legacy class components

  /**
   * Render the content of the card.
   */
  renderContent() {
    let account = this.props.account;
    let location = null;

    if (account && account.locationId !== null) {
      location = this.context.locationsIndexed[account.locationId];
    }

    // Location
    const handleEditLocation = () => {
      this.setState({ locationDialogOpen: true });
    };
    const handleClearLocation = () => {
      this.props.onChange({ locationId: null });
    };
    const locationIconButtons = [
      <MUIIconButton disabled={!account?.ownerId} onClick={handleEditLocation}>
        <MUIEditIcon />
      </MUIIconButton>,
    ];

    if (location) {
      locationIconButtons.push(
        <MUIIconButton onClick={handleClearLocation}>
          <MUIDeleteIcon />
        </MUIIconButton>,
      );
    }

    const accountTypeOptions = Object.values(this.context.accountTypes).sort(
      (a, b) => a.name.localeCompare(b.name),
    );
    let salesRepOptions = User.getSalesReps(this.context.usersIndexed);
    const selectedUser = this.context.usersIndexed[this.props.account?.ownerId];
    const locationOptions = Object.values(
      this.context.userprofileLocationsIndexed,
    )
      .filter(
        (userprofileLocation) =>
          userprofileLocation.userprofileId === this.props.account?.ownerId,
      )
      .map(
        (userprofileLocation) =>
          this.context.locationsIndexed[userprofileLocation.locationsId],
      )
      .filter((ownerLocation) => ownerLocation != null);

    if (
      this.props.account?.id &&
      location &&
      !locationOptions.find((ownerLocation) => ownerLocation.id === location.id)
    ) {
      locationOptions.push(location);
    }

    if (!salesRepOptions.includes(selectedUser) && selectedUser) {
      salesRepOptions.push({ ...selectedUser });
    }
    return (
      <MUIGrid container spacing={2}>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUITextField
            value={
              this.props.account && this.props.account.name
                ? this.props.account.name
                : ""
            }
            autoFocus={true}
            size="small"
            label="Name"
            variant="standard"
            fullWidth={true}
            inputProps={{
              maxLength: 255,
            }}
            InputLabelProps={{ shrink: true }}
            onBlur={(e) => this.props.onChange({ name: e.target.value.trim() })}
            onChange={(e) => this.props.onChange({ name: e.target.value })}
            required={true}
            error={this.props.validationIssues.name ? true : false}
            helperText={
              this.props.validationIssues.name
                ? this.props.validationIssues.name
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUIAutoComplete
            options={salesRepOptions}
            value={
              this.props.account
                ? salesRepOptions.find(
                    (option) => option.id === this.props.account?.ownerId,
                  ) || null
                : null
            }
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => User.getDisplayName(option)}
            onChange={(e, value) => {
              const selectedOwnerLocations = value
                ? Object.values(this.context.userprofileLocationsIndexed)
                    .filter(
                      (userprofileLocation) =>
                        userprofileLocation.userprofileId === value.id,
                    )
                    .map(
                      (userprofileLocation) =>
                        this.context.locationsIndexed[
                          userprofileLocation.locationsId
                        ],
                    )
                    .filter((ownerLocation) => ownerLocation != null)
                : [];

              this.props.onChange({
                ownerId: value ? value.id : null,
                locationId:
                  !this.props.account?.id && selectedOwnerLocations.length === 1
                    ? selectedOwnerLocations[0].id
                    : null,
              });
            }}
            renderInput={(params) => (
              <MUITextField
                {...params}
                InputLabelProps={{ shrink: true }}
                size="small"
                variant="standard"
                label="Sales Rep"
                required={true}
                fullWidth
                error={
                  this.props.validationIssues &&
                  this.props.validationIssues.ownerId
                    ? true
                    : false
                }
                helperText={
                  this.props.validationIssues
                    ? this.props.validationIssues.ownerId
                    : ""
                }
              />
            )}
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUIAutoComplete
            options={accountTypeOptions}
            value={
              this.props.account
                ? accountTypeOptions.find(
                    (option) => option.id === this.props.account.accountTypeId,
                  ) || null
                : null
            }
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.name}
            onChange={(e, value) =>
              this.props.onChange({ accountTypeId: value ? value.id : null })
            }
            renderInput={(params) => (
              <MUITextField
                {...params}
                InputLabelProps={{ shrink: true }}
                size="small"
                variant="standard"
                label="Account Type"
                required={true}
                fullWidth
                error={
                  this.props.validationIssues &&
                  this.props.validationIssues.accountTypeId
                    ? true
                    : false
                }
                helperText={
                  this.props.validationIssues
                    ? this.props.validationIssues.accountTypeId
                    : ""
                }
              />
            )}
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={6} md={4}>
          <TileRegion
            region={location}
            iconButtons={locationIconButtons}
            label="Location"
            required={true}
            error={this.props.validationIssues.locationId ? true : false}
            helperText={
              this.props.validationIssues.locationId
                ? this.props.validationIssues.locationId
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUIFormControlLabel
            control={
              <MUICheckbox
                checked={
                  this.props.account && this.props.account.isMaster
                    ? true
                    : false
                }
                onChange={(e) =>
                  this.props.onChange({
                    isMaster: e.target.checked,
                    masterAccountId: null,
                  })
                }
              />
            }
            label="Is Master Account"
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUIFormControlLabel
            control={
              <MUICheckbox
                checked={
                  this.props.account && this.props.account.isTarget
                    ? true
                    : false
                }
                onChange={(e) =>
                  this.props.onChange({ isTarget: e.target.checked })
                }
              />
            }
            label="Is Target Account"
          />
        </MUIGrid>
        <DialogSearchLocation
          data={locationOptions}
          open={this.state.locationDialogOpen}
          onClose={() => this.setState({ locationDialogOpen: false })}
          onSelect={(location) => {
            this.props.onChange({ locationId: location.id });
          }}
        />
      </MUIGrid>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "General";
  }
}
